export interface ICompanyIntraModule {
    code: string;
    name: string;
    externalCode: string;
    inUse: boolean;
    usesExternalCode: boolean;
}

export class CompanyIntraModule implements ICompanyIntraModule {
    code: string;
    name: string;
    externalCode: string;
    inUse: boolean;
    usesExternalCode: boolean;

    constructor();
    constructor(obj: ICompanyIntraModule);
    constructor(obj?: any) {
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.externalCode = obj && obj.externalCode || "";
        this.inUse = obj && obj.inUse || false;
        this.usesExternalCode = obj && obj.usesExternalCode || false;
    }
}

export class CompanySaveIntraModule {
    code: string;
    externalCode: string;

    constructor();
    constructor(obj: ICompanyIntraModule);
    constructor(obj?: any) {
        this.code = obj && obj.code || "";
        this.externalCode = obj && obj.externalCode || "";
    }
}